module.exports = __webpack_public_path__ + "img/order_review.c06e2c5e.png";